export default __webpack_public_path__ + "static/media/btn_orange.09c9df48.png";